import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-hero-employee-header',
  templateUrl: './hero-employee-header.component.html',
  styleUrls: ['./hero-employee-header.component.less'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class HeroEmployeeHeaderComponent {
  @Input() user: any;
  @Input() dealer: any;
}
